<template>
  <div>
    <!-- main-area -->
    <main class="fix">
      <!-- breadcrumb-area -->
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb__content">
                <h2 class="title">Anggota DPRD Kab. Konawe Selatan</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Profil</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Profil Dewan</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>

      <!-- team / anggota dewan -->
      <section class="team__area-two">
        <div class="container">
          <div class="row justify-content-center mb-4">
            <div class="col-lg-6 col-md-8 col-sm-10">
              <div class="form-group position-relative">
                <label for="filterMasaJabatan" class="form-label fw-semibold mb-2">Masa Jabatan</label>
                <select id="filterMasaJabatan" class="form-select custom-select shadow-sm"
                  @change="onChangeFilter($event)">
                  <option disabled value="">-- Masa Jabatan --</option>
                  <option v-for="masa in list_masa_jabatan" :key="masa.id" :value="masa.id">
                    {{ masa.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div class="row justify-content-center gutter-24">
              <div class="col-lg-3 col-md-6 col-sm-8" v-for="(data) in list_data" :key="data.id">
                <div class="team__item-two shine-animate-item">
                  <div class="team__thumb-two shine-animate">
                    <img :src="data.file ? file_path + data.file : 'assets/img/user.png'" alt="Foto Pegawai" />
                  </div>
                  <div class="team__content-two">
                    <h4 class="title"><a href="javascript:void(0);">{{ data.nama }}</a></h4>
                    <span>{{ data.jabatan_dprd }}</span>
                    <br />
                    <small>{{ data.nama_partai }} | {{ data.nama_fraksi }}</small><br />
                    <small>Masa Jabatan: {{ data.masa_jabatan_label }}</small>
                  </div>
                </div>
              </div>
            </div> -->

          <!-- Struktur Ketua & Wakil -->
          <div class="struktur-dewan text-center mb-5">
            <!-- Ketua -->
            <div v-if="ketua" class="mb-4">
              <div class="team__item-two d-inline-block">

                <div class="team__thumb-two shine-animate" @click="openModal(ketua)" data-bs-toggle="modal"
                  data-bs-target="#dewanModal" style="cursor: pointer;">
                  <img :src="getFoto(ketua)" alt="Foto Ketua" />
                </div>
                <div class="team__content-two">
                  <h4 class="title">{{ ketua.nama }}</h4>
                  <span>{{ ketua.jabatan_dprd }}</span>
                </div>
              </div>
            </div>

            <!-- Wakil (berjejer) -->
            <div class="row justify-content-center">
              <div class="col-lg-3 col-md-4 col-sm-6" v-for="(item, i) in wakil" :key="'wakil-' + i">
                <div class="team__item-two shine-animate-item">
                  <div class="team__thumb-two shine-animate" @click="openModal(item)" data-bs-toggle="modal"
                    data-bs-target="#dewanModal" style="cursor: pointer;">
                    <img :src="getFoto(item)" alt="Foto Wakil" />
                  </div>
                  <div class="team__content-two">
                    <h4 class="title">{{ item.nama }}</h4>
                    <span>{{ item.jabatan_dprd }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Daftar Anggota Lain -->
          <div class="row justify-content-center gutter-24">
            <div class="col-lg-3 col-md-6 col-sm-8" v-for="(data) in anggotaLain" :key="data.id">
              <div class="team__item-two shine-animate-item">
                <div class="team__thumb-two shine-animate" @click="openModal(data)" data-bs-toggle="modal"
                  data-bs-target="#dewanModal" style="cursor: pointer;">
                  <img :src="getFoto(data)" alt="Foto Anggota" />
                </div>
                <div class="team__content-two">
                  <h4 class="title">{{ data.nama }}</h4>
                  <span>{{ data.jabatan_dprd }}</span>
                </div>
              </div>
            </div>
          </div>




          <!-- Pagination -->
          <div class="pagination-wrap mt-10">
            <nav aria-label="Page navigation example">
              <ul class="pagination list-wrap">
                <li class="page-item" :class="{ disabled: page_first === 1 }">
                  <a class="page-link" href="#" @click.prevent="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                </li>
                <li v-for="page in paginationPages" :key="page"
                  :class="{ active: page === page_first, disabled: page === '...' }" class="page-item">
                  <a v-if="page !== '...'" class="page-link" href="#" @click.prevent="go_to_page(page)">
                    {{ page }}
                  </a>
                  <span v-else class="page-link">...</span>
                </li>
                <li class="page-item" :class="{ disabled: page_first === page_last }">
                  <a class="page-link" href="#" @click.prevent="btn_next"><i class="fas fa-angle-double-right"></i></a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div class="about__shape-wrap-four">
          <img src="assets/img/images/h4_about_shape01.png" alt="" />
          <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }' />
        </div>
      </section>
    </main>
  </div>

  <!-- Modal Detail Dewan -->
  <div class="modal fade" id="dewanModal" tabindex="-1" aria-labelledby="dewanModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow-lg">
        <div class="modal-header text-white">
          <h5 class="modal-title" id="dewanModalLabel">{{ form.nama }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- Foto -->
            <div class="col-md-5 text-center mb-3 mb-md-0">
              <img :src="file_path + form.file" alt="Foto Detail" class="img-fluid rounded shadow-sm"
                style="max-height: 300px; object-fit: cover;" />
            </div>

            <!-- Info Detail -->
            <div class="col-md-7">
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Jabatan:</strong>
                  <span>{{ form.jabatan_dprd }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Daerah Pemilihan:</strong>
                  <span>{{ form.dapil }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Tempat, Tanggal Lahir:</strong>
                  <span>{{ form.ttl }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Agama:</strong>
                  <span>{{ form.agama }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Alamat:</strong>
                  <span>{{ form.alamat }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Partai:</strong>
                  <span>{{ form.nama_partai || '-' }}</span>
                </li>
                <li v-if="form.nama_fraksi" class="list-group-item d-flex justify-content-between">
                  <strong>Fraksi:</strong>
                  <span>{{ form.nama_fraksi }} <small v-if="form.jabatan_fraksi">({{ form.jabatan_fraksi
                  }})</small></span>
                </li>
                <li v-if="form.komisi" class="list-group-item d-flex justify-content-between">
                  <strong>Komisi:</strong>
                  <span>{{ form.komisi }} <small v-if="form.jabatan_komisi">({{ form.jabatan_komisi }})</small></span>
                </li>
                <li v-if="form.nama_badan || form.singkatan_badan"
                  class="list-group-item d-flex justify-content-between">
                  <strong>Badan:</strong>
                  <span>{{ form.nama_badan || form.singkatan_badan }} <small v-if="form.jabatan_badan">({{
                    form.jabatan_badan }})</small></span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Masa Jabatan:</strong>
                  <span>{{ form.masa_jabatan_label }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




</template>

<script>
export default {
  data() {
    return {
      form: {
        id: '',
        nama: '',
        dapil: '',
        jabatan_dprd: '',
        uraian: '',
        masa_jabatan_label: '',
        foto: '',
        unit_kerja: '',
        status: '',
        keterangan: '',
      },
      list_data: [],
      page_first: 1,
      page_last: 0,
      perPage: 12,
      masa_jabatan: "",
      selectedDewan: null,

      cari_value: "",
      file_path: this.$store.state.URL_APP + "uploads/",
      masa_jabatan_selected: "",
      list_masa_jabatan: [],
    };
  },

  computed: {
    paginationPages() {
      const pages = [];
      const total = this.page_last;
      const current = this.page_first;

      if (total <= 5) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, '...', total);
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 2, total - 1, total);
        } else {
          pages.push(1, '...', current, '...', total);
        }
      }

      return pages;
    },
    ketua() {
      return this.list_data.find(item => {
        const jabatan = item.jabatan_dprd?.toLowerCase() || '';
        return jabatan.includes("ketua") && !jabatan.includes("wakil");
      });
    },
    wakil() {
      return this.list_data.filter(item =>
        item.jabatan_dprd?.toLowerCase().includes("wakil")
      );
    },
    anggotaLain() {
      return this.list_data.filter(item => {
        const jabatan = item.jabatan_dprd?.toLowerCase() || '';
        return !jabatan.includes("ketua") && !jabatan.includes("wakil");
      });
    },
  },

  methods: {
    openModal(data) {
      if (!data) {
        console.warn("Data tidak tersedia");
        return;
      }
      this.selectData(data);
    },
    getFoto(item) {
      if (!item || !item.file) {
        return 'assets/img/user.png'; // fallback gambar default
      }
      return this.file_path + item.file;
    },
    getView() {

      fetch(this.$store.state.ADD_URL_DEWAN + "view", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          masa_jabatan: this.masa_jabatan_selected
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_data = res_data.data || [];

          // Hitung jumlah halaman berdasarkan data total
          const total = res_data.total_data || 0;
          const per_page = res_data.per_page || 12;
          this.page_last = Math.ceil(total / per_page) || 1;
        })
        .catch((err) => {
          console.error("Gagal ambil data:", err);
        });
    },

    getMasaJabatan() {
      fetch(this.$store.state.ADD_URL_MASA_JABATAN + "view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data_ke: 1 }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_masa_jabatan = res_data.data || [];
          if (this.list_masa_jabatan.length > 0) {
            const currentYear = new Date().getFullYear();
            const masaDefault = this.list_masa_jabatan.find(m => {
              const awal = parseInt(m.tahun_awal) || 0;
              const akhir = parseInt(m.tahun_akhir) || 9999;
              return currentYear >= awal && currentYear <= akhir;
            }) || this.list_masa_jabatan[0];

            if (masaDefault && masaDefault.id) {
              this.masa_jabatan_selected = masaDefault.id;
            }
          }

          this.getView();
        })
        .catch((err) => {
          console.error("Gagal ambil masa jabatan:", err);
          this.getView();
        });
    },

    selectData: function (data) {
      this.form = {
        id: data.id,
        nama: data.nama,
        jabatan_dprd: data.jabatan_dprd,
        ttl: data.ttl,
        partai: data.partai,
        dapil: data.dapil,
        agama: data.agama,
        alamat: data.alamat,
        nama_partai: data.nama_partai,
        nama_fraksi: data.nama_fraksi,
        jabatan_fraksi: data.jabatan_fraksi,
        komisi: data.komisi,
        jabatan_komisi: data.jabatan_komisi,
        nama_badan: data.nama_badan,
        singkatan_badan: data.singkatan_badan,
        jabatan_badan: data.jabatan_badan,
        masa_jabatan_label: data.masa_jabatan_label,
        file: data.file,
      };
    },

    btn_prev() {
      if (this.page_first > 1) {
        this.page_first--;
        this.getView();
      }
    },
    btn_next() {
      if (this.page_first < this.page_last) {
        this.page_first++;
        this.getView();
      }
    },
    go_to_page(page) {
      if (page !== "...") {
        this.page_first = page;
        this.getView();
      }
    },
    onChangeFilter(event) {
      const selectedId = event.target.value;
      this.masa_jabatan_selected = selectedId;
      this.getView();
    },
  },

  mounted() {
    this.getMasaJabatan();
    this.getView();  // langsung ambil data saat halaman dimuat
  }
};
</script>